import React from 'react';
import PropTypes from 'prop-types';

import { cn } from 'helpers/classnames';
import { Box, Check, Truck } from 'components/icons';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/account/trackingProgress.scss';

export const TrackingProgress = ({ isShipped, isDelivered, estimatedDeliveryDate }) => {
  const trackClass = isDelivered ? css.trackDelivered : isShipped ? css.trackTransit : '';

  return (
    <div className={css.wrapper}>
      {estimatedDeliveryDate && <div className={css.estimatedDeliveryDate}>Estimated Delivery: {estimatedDeliveryDate}</div>}
      <div className={cn(css.trackingProgress, trackClass)}>
        <div className={css.progress}>
          <div className={css.bar}>
            <div className={css.barFill} />
          </div>
          <div className={cn(css.point, css.placed)}>
            <div className={css.bullet}>
              <Check size={30} />
            </div>
            <div className={css.label}>Order Placed</div>
          </div>
          <div className={cn(css.point, css.transit)}>
            <div className={css.bullet}>
              <Truck size={30} />
            </div>
            <div className={css.label}>In Transit</div>
          </div>
          <div className={cn(css.point, css.delivered)}>
            <div className={css.bullet}>
              <Box size={30} />
            </div>
            <div className={css.label}>Delivered</div>
          </div>
        </div>
      </div>
    </div>
  );
};

TrackingProgress.propTypes = {
  estimatedDeliveryDate: PropTypes.string
};

TrackingProgress.displayName = 'TrackingProgress';

export default withErrorBoundary(TrackingProgress.displayName, TrackingProgress);
